export default __webpack_public_path__ + "static/media/1.6d72fd50.png";